<script setup lang="ts">
interface Props {
  text: string
  tagline?: string | null
  type?: 'title' | 'subtitle'
  icon?: string | null
  noWrap?: boolean
  padding?: 'large' | 'small'
}

const props = withDefaults(defineProps<Props>(), {
  type: 'title',
  padding: 'small',
  tagline: null,
  icon: null,
})

const dinamicClasses = computed(() => ({
  'text-xl md:text-2xl lg:text-3xl': props.type === 'title',
  'text-lg lg:text-xl': props.type === 'subtitle',
  'flex items-center gap-2': !!props.icon,
  'py-5': props.padding === 'large',
  'py-1': props.padding === 'small',
}))
</script>

<template>
  <div
    :class="dinamicClasses"
    class="leading-tight title-component"
  >
    <span
      v-if="icon"
      class="flex aspect-square items-center justify-center rounded-lg bg-primary p-2 title-icon-container"
    >
      <span
        class="text-lg lg:text-xl text-white tracking-tighter"
        :class="icon"
      />
    </span>
    <div
      class="title-text"
      :class="noWrap ? 'text-nowrap' : ''"
    >
      <span class="font-bold">
        {{ text }}
      </span>

      {{ tagline }}
    </div>
  </div>
</template>
